import { CardBody, Input, Table } from 'reactstrap';
import { Search } from 'react-feather';
import AttachModal from 'Component/Learning/Common/Modal/ModalButton';
import PaginationComponent from 'Component/Learning/Common/Pagination';

const CourseAttachMateriModal = ({
  // state & data
  modal,
  detail,
  selectedAttachItems,
  selectedAttachIds,
  filtersMateri,
  materiList,
  materiPagination,
  isLoadingMateri,
  // handlers
  toggle,
  handleSubmit,
  handleSearchClick,
  handleAttachCheckboxChange,
  // pagination helpers
  handleBackPagination,
  handleClickPagination,
  handleNextPagination,
  // redux helpers
  dispatch,
  setFilters,
  setRefetch,
}) => {
  return (
    <AttachModal
      colorBtn={'primary'}
      item={detail}
      buttonLabel={'Tambah Materi'}
      toggle={toggle}
      modalLabel={'Tambah Materi Course'}
      modal={modal}
      handleSubmit={handleSubmit}
    >
      {/* list pilihan materi yang akan di-attach */}
      <ul>
        {selectedAttachItems.length > 0 &&
          selectedAttachItems.map((item, index) => (
            <li key={`attach-item-${index}`}>
              {item.id} - {item.name}
            </li>
          ))}
      </ul>
      <div className="faq-form mt-3">
        <Input
          className="form-control"
          type="text"
          placeholder="Search.."
          value={filtersMateri['filter[name]']}
          onKeyUp={(e) => (e.key === 'Enter' ? handleSearchClick() : null)}
          onChange={(e) => {
            // update filter name untuk search materi
            dispatch(
              setFilters({
                ...filtersMateri,
                'filter[name]': e.target.value,
                page: 1,
              })
            );
          }}
        />
        <Search className="search-icon" onClick={handleSearchClick} />
      </div>
      <Table className="table-responsive table-bordered my-3">
        <thead className="table-light">
          <tr>
            <th scope="col">#</th>
            <th scope="col">ID</th>
            <th scope="col">Nama Materi</th>
            <th scope="col" className="text-center">
              Aksi
            </th>
          </tr>
        </thead>
        <tbody>
          {materiList &&
            materiList.map((item, index) => (
              <tr key={`materi-${index}`}>
                <th>{index + 1}</th>
                <th>{item.id}</th>
                <td>{item.name}</td>
                <td className="text-center">
                  <Input
                    className="checkbox_animated"
                    id={`attach-${item.id}`}
                    type="checkbox"
                    checked={selectedAttachIds.includes(item.id)}
                    onChange={() => handleAttachCheckboxChange(item)}
                  />
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
      {!isLoadingMateri && materiPagination && (
        <CardBody>
          <PaginationComponent
            pagination={materiPagination}
            handleBackPagination={() =>
              handleBackPagination(
                materiPagination,
                filtersMateri,
                dispatch,
                setFilters,
                setRefetch
              )
            }
            handleClickPagination={(page) =>
              handleClickPagination(
                page,
                filtersMateri,
                dispatch,
                setFilters,
                setRefetch
              )
            }
            handleNextPagination={() =>
              handleNextPagination(
                materiPagination,
                filtersMateri,
                dispatch,
                setFilters,
                setRefetch
              )
            }
          />
        </CardBody>
      )}
    </AttachModal>
  );
};

export default CourseAttachMateriModal;